import {API_URL} from "../../../components/config/BaseUrl";

export const GROUPS_URL = `${API_URL}/wificall/groups/campaign`;
